import FlatListItem from './flat_list_item'

export default FlatListItem
